export const googleApiKey = 'AIzaSyDQ90b6zBbkozSHwN88U_qkKQpI_A4wHYk'

export const payKeeperUrl = 'https://app-dev.paykeeper.com'
